import { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';

import {
  Center,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Spinner,
} from '@frontend/components';

import { GenericError } from 'modules/common/components';

import { BillingAddressForm } from './BillingAddressForm';
import { billingAddressDrawer } from './data/actions';
import { MODES } from './data/constants';
import { getIsLoading, getIsOpen, getMode } from './data/reducer';

const BillingAddressDrawer = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const isOpen = useSelector(getIsOpen);
  const mode = useSelector(getMode);
  const close = useCallback(() => {
    dispatch(billingAddressDrawer.close());
  }, [dispatch]);

  return (
    <Drawer onClose={close} isOpen={isOpen} size="sm">
      <DrawerContent>
        <DrawerHeader>
          {mode === MODES.CREATE
            ? 'Create New Billing Address'
            : 'Edit Billing Address'}
          <DrawerCloseButton />
        </DrawerHeader>
        <ErrorBoundary FallbackComponent={() => <GenericError pt={3} />}>
          {isLoading ? (
            <Center flex={1}>
              <Spinner size="lg" />
            </Center>
          ) : (
            <BillingAddressForm />
          )}
        </ErrorBoundary>
      </DrawerContent>
    </Drawer>
  );
};

export default BillingAddressDrawer;
